import {
    TeamOutlined,
    SolutionOutlined,
    MessageOutlined,
    MailOutlined,
    CalendarOutlined,
    BellOutlined,
    CheckCircleOutlined,
    ScheduleOutlined,
    SafetyOutlined,
    UserAddOutlined,
    FileTextOutlined,
    DollarOutlined,
    HeartOutlined,
    AlertOutlined,
    BookOutlined,
    StarOutlined,
    GiftOutlined,
} from '@ant-design/icons';

/**
 * Template catalog category taxonomy.
 *
 * Mirrors backend-gohire-v2/lib/template-categories.js.
 * Used to build the DirectoryTree in CatalogBrowser.
 */
export const SECTIONS = [
    {
        key: 'recruiting',
        label: 'Recruiting Templates',
        icon: TeamOutlined,
        children: [
            { key: 'recruiting/candidate-outreach',    label: 'Candidate Outreach',      icon: MessageOutlined },
            { key: 'recruiting/application-follow-up', label: 'Application Follow-Up',   icon: MailOutlined },
            { key: 'recruiting/interview-scheduling',  label: 'Interview Scheduling',    icon: CalendarOutlined },
            { key: 'recruiting/interview-reminders',   label: 'Interview Reminders',     icon: BellOutlined },
            { key: 'recruiting/post-interview',        label: 'Post-Interview',          icon: CheckCircleOutlined },
            { key: 'recruiting/job-fairs-events',      label: 'Job Fairs & Events',      icon: ScheduleOutlined },
            { key: 'recruiting/tcpa-opt-in',           label: 'TCPA / Opt-In',           icon: SafetyOutlined },
        ],
    },
    {
        key: 'hr',
        label: 'HR Employee Communication',
        icon: SolutionOutlined,
        children: [
            { key: 'hr/new-hire-onboarding',   label: 'New Hire Onboarding',   icon: UserAddOutlined },
            { key: 'hr/general-comms',         label: 'General HR Comms',      icon: FileTextOutlined },
            { key: 'hr/payroll-notifications', label: 'Payroll Notifications', icon: DollarOutlined },
            { key: 'hr/benefits-enrollment',   label: 'Benefits & Enrollment', icon: HeartOutlined },
            { key: 'hr/emergency-alerts',      label: 'Emergency Alerts',      icon: AlertOutlined },
            { key: 'hr/training-development',  label: 'Training & Development', icon: BookOutlined },
            { key: 'hr/surveys-feedback',      label: 'Surveys & Feedback',    icon: StarOutlined },
            { key: 'hr/employee-referrals',    label: 'Employee Referrals',    icon: GiftOutlined },
        ],
    },
];

/** Flat map: category key → label */
export const CATEGORY_LABELS = {};
for (const section of SECTIONS) {
    for (const child of section.children) {
        CATEGORY_LABELS[child.key] = child.label;
    }
}
